/* eslint-disable no-use-before-define */
import React from 'react'

export default ({orderInfo, bondInfo}) => {

    const [hasAttestCD, setHasAttestCD] = React.useState(false)
    const [hasAttestCorp, setHasAttestCorp] = React.useState(false)
    const [attestCD, setAttestCD] = React.useState(false)
    const [attestCorp, setAttestCorp] = React.useState(false)
    const [attested, setAttested] = React.useState(false)

    const updateAttested = ({bondInfo, hasAttestCD_, hasAttestCorp_, attestCD_, attestCorp_}) => {

        const prospectus = bondInfo && bondInfo.issue && bondInfo.issue.prospectus
        const isAttestCorp = hasAttestCorp_ && prospectus
        const a = (!hasAttestCD_ && !hasAttestCorp_)
            || (hasAttestCD_ && attestCD_)
            || (isAttestCorp && attestCorp_)
        setAttested(a)
    }

    React.useEffect(() => {
        if (!bondInfo) return

        updateAttested({
            bondInfo,
            hasAttestCD_:hasAttestCD,
            hasAttestCorp_:hasAttestCorp,
            attestCD_:attestCD,
            attestCorp_:attestCorp
        })
    }, [bondInfo, hasAttestCD, hasAttestCorp, attestCD, attestCorp])

    React.useEffect(() => {
        if (!bondInfo || !orderInfo) return

        const { issue } = bondInfo
        if (!issue) return

        const hasCD = orderInfo.action==='B'
            && issue.type==='S'
        setHasAttestCD(hasCD)

        const hasCorp = orderInfo.action==='B'
            && issue.type==='C'
            && orderInfo.primary==='Y'
        setHasAttestCorp(hasCorp)

        updateAttested({
            bondInfo,
            hasAttestCD_:hasCD,
            hasAttestCorp_:hasCorp,
            attestCD_:attestCD,
            attestCorp_:attestCorp
        })
    }, [bondInfo, orderInfo, attestCD, attestCorp])


    return {
        attested,
        hasAttestCD,
        hasAttestCorp,
        attestCD, setAttestCD,
        attestCorp, setAttestCorp
    }

}